import React from 'react';
import _get from 'lodash/get';
import { addHttps } from 'utils/stringUtils';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  audio: {
    width: '100%',
    flexShrink: 0,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    aspectRatio: '16/9',

    '& img': {
      flexGrow: '1',
      overflow: 'hidden',
      objectFit: 'cover',
      marginBottom: theme.spacing(1),
    },
  },
}));

export const PracticeAudio = ({ asset, practice, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {practice.image && (
        <img src={practice.image.fields.file.url} alt="Practice" />
      )}
      <audio controls autoPlay className={classes.audio} {...rest}>
        <source
          src={addHttps(_get(asset, 'fields.file.url'))}
          type={asset.fields.file.contentType}
        />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};
